/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskDetailArchivedReason = typeof TaskDetailArchivedReason[keyof typeof TaskDetailArchivedReason] | null;


export const TaskDetailArchivedReason = {
  skipped: 'skipped',
  enrollment_cancelled: 'enrollment_cancelled',
  enrollment_completed: 'enrollment_completed',
} as const;
